import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Resource } from 'app/shared/models/resource.model';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  imageUrl = environment.apiUrls.imageUrl;
  imgUrl: any;
  pdfUrl: any;
  resourceForm: FormGroup;
  fileData: File
  fileDataa: File
  resource: any = new Resource();
  resourceSubmitted: boolean = false;
  isEdit = false;
  docsUrl = environment.apiUrls.pdfUrl
  readFor_list =[
    { name:'All',_id:'all'},
    {name:'Teacher',_id:'teacher'},
    { name:'Student',_id:'student' }
  ]
  selected_readFor=null
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService: ApiService,
    private route: Router,
    private session: SessionStorageService) {
    let value = session.getObject('resource-data')
    if (value != null) {
      this.resource = value;
      this.selected_readFor=this.resource.read_for
      this.isEdit = true;
    }
    console.log('==>>', this.resource)
  }

  ngOnInit() {
    this.selected_readFor='all'
    this.resourceForm = this.formBuilder.group({
      content: ['', Validators.required],
      description: ['', Validators.required],
      documents: ['',],
      image: ['',],
    })
  }

  ngOnDestroy() {
    this.session.removeItem('resource-data')
  }
  get rf() {
    return this.resourceForm.controls;
  }
  getReadForId(event:any){
    this.selected_readFor
  }
  submit() {

    let formData = new FormData()
    formData.append('content', this.resourceForm.controls.content.value),
      formData.append('description', this.resourceForm.controls.description.value),
      formData.append('documents', this.fileDataa),
      formData.append('image', this.fileData),
      formData.append('read_for', this.selected_readFor),
      this.apiService[this.isEdit ? 'updateResource' : 'createResource'](this.resource.id, formData).subscribe((res: any) => {
        console.log('resources', res)
        if (res.statusCode === 200) {
          this.toastr.success(`${this.isEdit ? 'Updated ' : 'Created '}Successfully`, '')
          this.route.navigate(['/resources/list'])
        }
        else { this.toastr.error(res.error) }
      })
  }
  back() {
    this.route.navigate(['/resources/list'])
  }
  //  onSelectFile(event:any){
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     this.fileData = event.target.files[0];
  //     reader.readAsDataURL(event.target.files[0]);
  //     console.log('event',this.fileData)
  //   }
  // }
  onSelectFile(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.imgUrl = reader.result

      }
      console.log('event', this.fileData)
    }
  }
  onSelectFilePdf(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileDataa = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.pdfUrl = reader.result
      }
      console.log('event', this.fileDataa)
    }
  }

}
